class PopularPostsHoverPreview {
  constructor() {
    /** @type {NodeListOf<HTMLElement>} */
    this.items = document.querySelectorAll('.popular-posts .popular-posts__item');

    if (!this.items.length) return;

    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);

    this.init();
  }

  init() {
    this.items.forEach((item) => {
      const imageWrap = item.querySelector('.popular-posts__item-image');

      if (!imageWrap) return;

      item.addEventListener('mouseenter', this.handleMouseEnter);
      item.addEventListener('mouseleave', this.handleMouseLeave);
      item.addEventListener('mousemove', this.handleMouseMove);
    });
  }

  /**
   * @param {MouseEvent} event
   */
  handleMouseEnter(event) {
    const item = event.currentTarget;
    const imageWrap = item.querySelector('.popular-posts__item-image');
    if (!imageWrap) return;

    imageWrap.classList.add('popular-posts__item-image--visible');
  }

  /**
   * @param {MouseEvent} event
   */
  handleMouseLeave(event) {
    const item = event.currentTarget;
    const imageWrap = item.querySelector('.popular-posts__item-image');
    if (!imageWrap) return;

    imageWrap.classList.remove('popular-posts__item-image--visible');
  }

  /**
   * @param {MouseEvent} event
   */
  handleMouseMove(event) {
    const item = event.currentTarget;
    const imageWrap = item.querySelector('.popular-posts__item-image');
    if (!imageWrap) return;

    const viewportWidth = window.innerWidth;

    if (viewportWidth <= 1280) return;

    const cursorOffsetX = 20;
    const cursorOffsetY = 0;

    let x = event.clientX + cursorOffsetX;
    let y = event.clientY + cursorOffsetY;

    const rect = imageWrap.getBoundingClientRect();

    const overflowRight = x + rect.width - viewportWidth;
    if (overflowRight > 0) {
      x -= overflowRight + 20;
    }

    const viewportHeight = window.innerHeight;
    const overflowBottom = y + rect.height - viewportHeight;
    if (overflowBottom > 0) {
      y -= overflowBottom + 20;
    }

    if (y < 0) y = 0;

    imageWrap.style.transform = `translate3d(${x}px, ${y}px, 0)`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new PopularPostsHoverPreview();
});

